export async function formDataHandler(payload) {
    return new Promise(async (resolve, reject) => {
        try {

            var formData = new FormData();
            if (payload.file) {

                if (payload.file.size && payload.file.size > 0) {
                    formData.append('file', payload.file)
                }

                delete payload.file
                formData.append('data', JSON.stringify(payload))
                formData.append('data_to_parse', true)
                resolve(formData)

            }else {

                formData.append('data', JSON.stringify(payload))
                formData.append('data_to_parse', true)
                resolve(formData)

            }



        } catch (error) {
            console.log(error.stack);
            console.log(error.message);
            resolve(false)
        }

    });
}

